<template>
	<div>
		<div class="form-group row pb-3">
			<div class="col-lg-12">
				<label for="" class="bold">Número de Contrato</label>
				<input :readonly="!this.fallo || this.TipoContrato==1" type="text" class="form-control" v-model="Contrato">
			</div>
		</div>
		<div class="form-group row mb-3" v-show="TipoSpendPlan=='1'">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<input type="hidden" :value="calcularValores">
				<div class="table-finanzas">
					<CLoader :pConfigLoad="ConfigLoadSpendPlan">
						<template slot="BodyFormLoad">
							<table class="table-fin-05">
								<thead>
									<tr>
										<th class="sticky mediana marca"><b>Descripción</b></th>
										<th class="mediana text-center">Plan</th>
										<th class="mediana text-center">%</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item,index) in ListaDetalle" :key="index">
										<td :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' ">
											<b>{{item.Descripcion}}</b>
										</td>
										<template>
											<td v-if="item.Descripcion === 'Facturacion'" :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' "><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan" />  </td>
											<td v-if="item.Descripcion === 'Materiales'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
											<td v-if="item.Descripcion === 'Equipos'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
											<td v-if="item.Descripcion === 'Mano de Obra'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
											<td v-if="item.Descripcion === 'Vehiculos'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
											<td v-if="item.Descripcion === 'Contratistas'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
											<td v-if="item.Descripcion === 'Viaticos'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
											<td v-if="item.Descripcion === 'Burden'"><Cmoneda :activo="BlockCampos" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										</template>
										<td v-if="item.Descripcion === 'Facturacion' " :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Materiales'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Equipos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Mano de Obra'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Vehiculos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Contratistas'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Viaticos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
										<td v-if="item.Descripcion === 'Burden'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									</tr>
								</tbody>
								<tfoot>
									<tr>
										<td class="color-01 bold sticky marca">Costo Operacional</td>
										<td><Cmoneda 	 :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="CostoOpPlan"/></td>
										<td><Cporcentaje :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="CostoOpPlanPorcent"/></td>
									</tr>
									<tr>
										<td class="color-01 bold sticky marca">Gross Profit</td>
										<td><Cmoneda 	 :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="GpPlan"/></td>
										<td><Cporcentaje :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="GpPlanPorcent"/></td>
									</tr>
								</tfoot>
							</table>
						</template>
					</CLoader>
				</div>
			</div>
		</div>
		<div class="modal-footer f1-buttons mt-4 mx-0 px-0">
		<button :disabled="DisableBtn" @click="Guardar" type="button" class="btn btn-01">
			<i v-show="DisableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
			<i class="fa fa-plus-circle"></i>
			Guardar
		</button>
	</div>
	</div>
</template>

<script>
export default {
	props:['pOrigen'],
	data() {
		return {
			ConfigLoad:{
				ShowLoader:false,
				ClassLoad:true
			},
			ConfigLoadSpendPlan:{
				ShowLoader:true,
				ClassLoad:true
			},
			Contrato:'',
			DisableBtn:false,
			BlockCampos:false,
			fallo:false,
			ListaDetalle:[
				{Descripcion:'Facturacion',MontoPlan:0,PorcentPlan:100},
				{Descripcion:'Equipos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Materiales',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Mano de Obra',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Vehiculos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Viaticos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Burden',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Contratistas',MontoPlan:0,PorcentPlan:0},
			],
			CostoOpPlan:'',
            CostoOpPlanPorcent:'',
            GpPlan:'',
			GpPlanPorcent:'',
			SpendPlan:{
            },
			IdCotizacionServicio:'',
			TipoContrato:1,
			TipoSpendPlan:0
		}
	},
	methods: {
		Guardar(){
			let Origen='';
			if (this.pOrigen!=undefined) {
				Origen=this.pOrigen;
			}
			else{
				Origen='ventas';
			}
			this.DisableBtn=true;
			this.bus.$emit('Save_'+Origen,this.Contrato,this.ListaDetalle,this.TipoContrato,this.GpPlanPorcent);
		},
		RecuperaNumero(Tipo,Contrato='',TipoContrato){
			// console.log(Tipo);
			if (Tipo==3) {
				// console.log(Tipo);
				this.Contrato=Contrato;
			}
			else if (Tipo==1) {
				this.fallo=false;
				this.$http.get('foliocontratoexist/get',{
					params:{Tipo:TipoContrato}
				}).then((res)=>{
					let Folio=res.data.data.folio;
					this.Contrato=Folio.Serie+(parseInt(Folio.Numero)+1);
					if (Folio.Anio!='') {
						this.Contrato+='-'+Folio.Anio;
					}
				}).catch((err) => {
					this.fallo=true
				})	
			}
		},
		RecuperarSpendPlan(){
			this.ConfigLoadSpendPlan.ShowLoader=true;
			this.$http.get('cotizacion_servicio/recovery', {
				params:{
					IdCotizacionServicio: this.IdCotizacionServicio
				}
			}).then((res)=>{
				const Obj=res.data.data.cotizacion_servicio;
				this.ListaDetalle[0].MontoPlan=Obj.ValorVenta;
				this.ListaDetalle[1].MontoPlan=Obj.TotalEquipos;
				this.ListaDetalle[2].MontoPlan=Obj.TotalMateriales;
				this.ListaDetalle[3].MontoPlan=Obj.TotalManoDeObra;
				this.ListaDetalle[4].MontoPlan=Obj.TotalCostoKm;
				this.ListaDetalle[5].MontoPlan=Obj.TotalViaticos;
				this.ListaDetalle[6].MontoPlan=Obj.CostoBurden;
				this.ListaDetalle[7].MontoPlan=Obj.TotalContratistas;
			}).finally(()=>{
				this.ConfigLoadSpendPlan.ShowLoader=false;
			})
		},
		getPorcent($monto,$montoDivisor){
			let PORCENTAJE_FINA = 0;
			if (parseFloat($monto)  > 0) {
				if (parseFloat($montoDivisor) > 0){
					let decimal = ( parseFloat($monto) / parseFloat($montoDivisor) );
					let porcenTemp= (decimal * 100);
					porcenTemp = porcenTemp.toFixed(2);
					PORCENTAJE_FINA = (porcenTemp > 100) ? 100 : porcenTemp;
				}
			}
			return PORCENTAJE_FINA;
		},
		Limpiar(){
			this.ListaDetalle=[
				{Descripcion:'Facturacion',MontoPlan:0,PorcentPlan:100},
				{Descripcion:'Equipos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Materiales',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Mano de Obra',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Vehiculos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Viaticos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Burden',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Contratistas',MontoPlan:0,PorcentPlan:0},
			];
			this.BlockCampos=false;
			this.Contrato='';
			this.fallo=true;
		}
	},
	created() {
		this.bus.$off('EnableBtnContrato');
		this.bus.$on('EnableBtnContrato',()=>{
			this.DisableBtn=false
		})
		this.bus.$off('SetContrato');
		this.bus.$on('SetContrato',(Contrato,Tipo,TipoContrato,TipoSpendPlan,IdCotizacionServicio,ValorVenta)=>{
			this.ConfigLoad.ShowLoader=false;
			this.ConfigLoadSpendPlan.ShowLoader=false;
			this.Limpiar();
			this.TipoContrato=TipoContrato;

			this.IdCotizacionServicio=IdCotizacionServicio;
			if (TipoSpendPlan==1) {
				if (IdCotizacionServicio>0) {
					this.BlockCampos=true;
					this.RecuperarSpendPlan();	
				}
				else{
					this.BlockCampos=false;
				}
			}
			else{
				this.BlockCampos=false;
				this.ListaDetalle[0].MontoPlan=ValorVenta;
			}
			this.TipoSpendPlan=TipoSpendPlan;
			switch (TipoContrato) {
				case 1:
					this.RecuperaNumero(TipoContrato,'',Tipo);	
					break;
				case 3:
					this.RecuperaNumero(TipoContrato,Contrato);	
					break;
				default:
					break;
			}
		})
	},
	computed:{
		calcularValores(){
			let PlanFacturacion = 0;
			let CostoOpPlan = 0;
			for(let i=0;i<this.ListaDetalle.length;i++){
				if(i>0){
					if(this.ListaDetalle[i].Descripcion != '') {
						if( isNaN(this.ListaDetalle[i].MontoPlan) ) {
							CostoOpPlan += 0;
						}else {
							CostoOpPlan += parseFloat(this.ListaDetalle[i].MontoPlan);
						}
						// PORCENTAJE DE COLUMNA DE PLAN DE FACTURACIÓN
						this.ListaDetalle[i].PorcentPlan = this.getPorcent(this.ListaDetalle[i].MontoPlan, PlanFacturacion);
                    }
				}
				else {

                    if( isNaN(this.ListaDetalle[i].MontoPlan) ) {
						PlanFacturacion += 0;
                    }else {
						PlanFacturacion += parseFloat(this.ListaDetalle[i].MontoPlan);
					}
                }
			}
			this.CostoOpPlan 				= CostoOpPlan.toFixed(2);
			this.CostoOpPlanPorcent 		= this.getPorcent(CostoOpPlan, PlanFacturacion);
			let montoGP						= (PlanFacturacion - CostoOpPlan);
			this.GpPlan 					= montoGP;
			this.GpPlanPorcent				= this.getPorcent (montoGP, PlanFacturacion);
		}
	}
}
</script>

<style scoped>
	.table-fin-05 th,
.table-fin-05 td {
  min-width: 150px;
  padding: 0.3rem 1.5rem;
  text-align: left;
}
</style>
